import { render, staticRenderFns } from "./MFileInput.vue?vue&type=template&id=7840f750&scoped=true&"
import script from "./MFileInput.vue?vue&type=script&lang=js&"
export * from "./MFileInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7840f750",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VFileInput,VIcon})
